import React, { useState } from 'react'
import GenericPopUpModal from 'components/VirtualPortal/components/PopUpModal'
import noImage from '../../../images/no_image.png'

const WishlistRow = ({ surveyUser, onBlockedStatusChange, relevanceScore }) => {
  const [genericModalIsOpen, setGenericModalIsOpen] = useState(false)
  const [content, genericModalContent] = useState()
  const [className, genericModalCustomClass] = useState()
  const user = surveyUser.user
  let upButtonStatus = surveyUser.blocked_status === false ? 'selected' : ''
  let downButtonStatus = surveyUser.blocked_status === true ? 'selected' : ''
  function image(user) {
    if(user.photo) {
      return `<img class='rounded-circle' height='80' width='80' src=${user.photo} alt='' />`
    } else {
      return `<img height='80' src=${noImage} alt='' />`
    }
  }

  function bio(user) {
    if(user.bio) {
      return `<p>${user.bio}</p>`
    } else {
      return '<p>No information provided.</p>'
    }
  }

  function openUserDetailPopUp(user) {
    let userHeader = `
      <div class='user-list'>
      ${image(user)}
      <div class='user-info'>
        <div class='full-name'>${user.full_name}</div>
        <div class='title'>${user.title}</div>
        <div class='account-name'>${user.organization_name}</div>
      </div>
    </div>
    `
    let content = userHeader + `<div class='bio'><strong>Bio</strong>${bio(user)}</div>`
    setGenericModalIsOpen(true)
    genericModalContent(content)
    genericModalCustomClass('wishlist-user-info')
  }

  function buttonIcon(stringPosition, status) {
    let selectionStatus = status == 'selected' ? '-' : '-o-'
    let classString = `fa fa-2x fa-thumbs${ selectionStatus }${stringPosition} `
    return <i className={classString}></i>
  }

  return (
    <div key={surveyUser.id} className='wishlist-grid-content-row'>
      <div id={surveyUser.wishlistId} className='wishlist-grid-content wishlist-button-col'>
        <button
          data='false'
          className={'wishlist-button thumbs-up ' + upButtonStatus}
          onClick={ (e) => onBlockedStatusChange(surveyUser, e) }
        >
          {buttonIcon('up', upButtonStatus)}
        </button>
        <button
          data='true'
          className={'wishlist-button thumbs-down ' + downButtonStatus}
          onClick={ (e) => onBlockedStatusChange(surveyUser, e)  }
        >
          {buttonIcon('down', downButtonStatus)}
        </button>
      </div>
      <div className='wishlist-grid-content'><span>{user.organization_name}</span></div>
      <div className='wishlist-grid-content'>
        <span><a className='user-detail-link' onClick={() => openUserDetailPopUp(user)}>{user.full_name}</a></span>
        { genericModalIsOpen ?
          <GenericPopUpModal
            customClass={className}
            handleCloseGenericModal={() => setGenericModalIsOpen(false)}
            content={content} >
          </GenericPopUpModal>
          : '' }
      </div>
      <div className='wishlist-grid-content title-col'><span>{user.title}</span></div>
      <div className='wishlist-grid-content'><span>{relevanceScore}</span></div>
      <hr className='row-hr' />
    </div>
  )
}

export default WishlistRow
